/**
 * Google Password Manager CSV 처리 (순환 참조 방지를 위해 파싱/검증/변환만 수행)
 * processImportData 호출은 bulkImport.js의 openImportFileWithSource에서 처리
 */
import { parseCsvRaw, isGooglePasswordCsv, convertGooglePasswordRows } from '../externalImport'

/**
 * Google Password CSV를 파싱하고 검증/변환
 * @returns {{ type: 'google'|'empty'|'error', records?: Array, skippedRows?: Array }}
 */
const parseGooglePasswordFile = (text) => {
  const parsed = parseCsvRaw(text)

  if (parsed.rows.length === 0) {
    return { type: 'empty' }
  }

  if (!isGooglePasswordCsv(parsed.headers)) {
    return { type: 'error' }
  }

  const { records, skippedRows } = convertGooglePasswordRows(parsed.rows)
  return { type: 'google', records, skippedRows }
}

export default parseGooglePasswordFile
